import React from 'react';

const LampIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries-large">
      <div className="vbz-icon-beneficiaries-large-lamp" />
    </div>
  );
};

export default LampIcon;
